import script from "./CanvasTextAction.vue?vue&type=script&setup=true&lang=js"
export * from "./CanvasTextAction.vue?vue&type=script&setup=true&lang=js"

import "./CanvasTextAction.vue?vue&type=style&index=0&id=77cf5954&lang=scss"

const __exports__ = script;

export default __exports__